export const orderKeys = {
  all: ['orders'] as const,
  orders: () => [...orderKeys.all, 'orders'] as const,
  waitTime: () => [...orderKeys.all, 'waitTime'] as const,
}
